import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdditionalFieldsVessel from './AdditionalFieldsVessel';
import AdditionalFieldsValue from './AdditionalFieldsValue';
import AdditionalFieldsCompany from './AdditionalFieldsCompany';
import AdditionalFieldsInsurance from './AdditionalFieldsInsurance';
import AdditionalFieldsSaving from './AdditionalFieldsSaving';
import AdditionalFieldsProperty from './AdditionalFieldsProperty';
import AdditionalFieldsVehicle from './AdditionalFieldsVehicle';
class AdditionalFields extends Component {
    constructor(props) {
        super(props);
        this.getAdditionalInfo = this.getAdditionalInfo.bind(this);
        this.setAdditionalInfo = this.setAdditionalInfo.bind(this);
        this.hasAdditionalData = this.hasAdditionalData.bind(this);
    }
    /**
     * Helper function to get additional data by key.
     *
     * @param {string} key
     *   The key of the additional data.
     * @param {string} defaultValue
     *   The default value if not set on the item.
     *
     * @return {string}
     */
    getAdditionalInfo(key, defaultValue = '') {
        const { data } = this.props;
        if (data.additional && data.additional[key]) {
            return data.additional[key].value;
        }
        return defaultValue;
    }
    /**
     * Set additional info on the item.
     *
     * @param {string} key
     *   The key on the additional container to set.
     * @param {string} label
     *   The label of the field.
     * @param {string} value
     *   The value of the field.
     */
    setAdditionalInfo(key, label, value) {
        const { data, setData } = this.props;
        if (!data.additional) {
            data.additional = {};
        }
        data.additional[key] = { label, value };
        // Notify the parent component of the change.
        setData('additional', data.additional);
    }
    /**
     * Check if additional data for the item is set.
     *
     * @param {string} key
     *
     * @return {boolean}
     */
    hasAdditionalData(key) {
        const { data } = this.props;
        if (!data.additional || typeof data.additional[key] === 'undefined' || !data.additional[key].value.length) {
            return false;
        }
        return true;
    }
    render() {
        const { data, validated } = this.props;
        const { type } = data;
        return (_jsxs("div", { children: [type === 'value' && (_jsx(AdditionalFieldsValue, { validated: validated, hasAdditionalData: this.hasAdditionalData, getAdditionalInfo: this.getAdditionalInfo, setAdditionalInfo: this.setAdditionalInfo })), type === 'vehicle' && (_jsx(AdditionalFieldsVehicle, { validated: validated, hasAdditionalData: this.hasAdditionalData, getAdditionalInfo: this.getAdditionalInfo, setAdditionalInfo: this.setAdditionalInfo })), type === 'property' && (_jsx(AdditionalFieldsProperty, { validated: validated, hasAdditionalData: this.hasAdditionalData, getAdditionalInfo: this.getAdditionalInfo, setAdditionalInfo: this.setAdditionalInfo })), type === 'vessel' && (_jsx(AdditionalFieldsVessel, { validated: validated, hasAdditionalData: this.hasAdditionalData, getAdditionalInfo: this.getAdditionalInfo, setAdditionalInfo: this.setAdditionalInfo })), type === 'saving' && (_jsx(AdditionalFieldsSaving, { validated: validated, hasAdditionalData: this.hasAdditionalData, getAdditionalInfo: this.getAdditionalInfo, setAdditionalInfo: this.setAdditionalInfo })), type === 'insurance' && (_jsx(AdditionalFieldsInsurance, { validated: validated, hasAdditionalData: this.hasAdditionalData, getAdditionalInfo: this.getAdditionalInfo, setAdditionalInfo: this.setAdditionalInfo })), type === 'company' && (_jsx(AdditionalFieldsCompany, { validated: validated, hasAdditionalData: this.hasAdditionalData, getAdditionalInfo: this.getAdditionalInfo, setAdditionalInfo: this.setAdditionalInfo }))] }));
    }
}
AdditionalFields.propTypes = {
    data: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    validated: PropTypes.bool.isRequired
};
export default AdditionalFields;
